import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import {
  ButtonComponent,
  CandidatesAvatarsComponent,
  IconComponent,
} from '@recruitee/user-interface';

import { AsyncJobsProgressDisplayModule } from '../async-jobs-progress-display/async-jobs-progress-display.module';
import { AsyncJobsNotificationComponent } from './async-jobs-notification.component';

@NgModule({
  imports: [
    AsyncJobsProgressDisplayModule,
    ButtonComponent,
    CandidatesAvatarsComponent,
    CommonModule,
    I18nModule,
    IconComponent,
    AsyncJobsNotificationComponent,
  ],
  exports: [AsyncJobsNotificationComponent],
})
export class AsyncJobsNotificationModule {}
